<template>
<div class='fw-avatar-card__wrapper h-flex h-flex-center h-flex-space-between h-pv-10 h-ph-20'>
    <div class='fw-avatar-card__image-text h-flex h-flex-center'>
        <div class='fw-avatar-card__image h-flex h-flex-center'
             :style='{
                 backgroundImage: avatarColor,
                 backgroundSize: `cover`,
                 backgroundRepeat: `no-repeat`,
                 backgroundPosition: `center`,
             }'>
            <FwIcon
                v-if='!avatarCardData.avatar_url'
                class='b-worker__avatar__icon'
                icon='no-avatar'
                :size='`16`'
                color='#fff'>
            </FwIcon>
        </div>
        <div class='fw-avatar-card__text h-mh-20'>
            <div class='fw-avatar-card__text--full'>
                <p v-if='avatarCardData.first_name || avatarCardData.last_name' class='h-m-0 h-font-16 h-fw-500'>
                    {{ avatarCardData.first_name }} {{ avatarCardData.last_name }}
                </p>
                <p v-else-if='avatarCardData.user_full_name' class='h-m-0 h-font-16 h-fw-500'>
                    {{ avatarCardData.user_full_name }}
                </p>
            </div>
            <span class='fw-avatar-card__text--label'>
                {{ userKind }}
            </span>
        </div>
    </div>
    <FwIcon
        class='h-flex'
        :icon='iconName'
        :size='iconSize'
        :color='iconColor'>
    </FwIcon>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

type AvatarCardDataType = {
    id: string,
    created_at: string | Date,
    updated_at: string | Date,
    email: string,
    first_name: string,
    last_name: string,
    locale: string,
    time_zone: string,
    account_id: string,
    kind: string,
    active: boolean,
    avatar_url: null | string,
    color: string,
    company_title: string,
    label: null
    user_color?: null
    user_full_name?: null
}

@Component
export default class FwAvatarCard extends Vue {
    @Prop({ type: Object, required: true }) readonly avatarCardData!: AvatarCardDataType;
    @Prop({ type: String, default: 'edit-settings' }) readonly iconName!: string;
    @Prop({ type: String, default: 'technician' }) readonly userKind!: string;
    @Prop({ type: String, default: '#adaeaf' }) readonly iconColor!: string;
    @Prop({ type: String, default: '21' }) readonly iconSize!: string;

    get avatarColor() {
        let result;
        if (this.avatarCardData.color || this.avatarCardData.user_color) {
            const colorArray = this.separateColor((this.avatarCardData.color || this.avatarCardData.user_color) as string);
            result = this.avatarCardData.avatar_url ?
                `linear-gradient(225deg, ${this.hexToRgbA(colorArray[0], 0.5)},  ${this.hexToRgbA(colorArray[1], 0.5)}),
             url(${this.avatarCardData.avatar_url})` :
                `linear-gradient(225deg, ${this.hexToRgbA(colorArray[0], 0)},  ${this.hexToRgbA(colorArray[1], 1)})`;
        } else {
            result = `linear-gradient(225deg, rgba(113, 143, 157, 0), rgba(105, 131, 165, 1))`;
        }
        return result;
    }
    hexToRgbA(hex: string, opacity: number) {
        let c: any;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split('');
            if (c.length === 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = `0x${c.join('')}`;
            return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},${opacity || 1})`;
        }
        throw new Error('Bad Hex');
    }

    separateColor(str: string) {
        return str.split(' - ');
    }

    editModal() {
        this.$emit('editModal', false);
    }
}
</script>

<style lang='sass'>
    .fw-avatar-card__wrapper
        border-radius: 10px
        background-color: #F7F8FA
        .fw-avatar-card__image
            width: 40px
            height: 40px
            border-radius: 50%
        .fw-avatar-card__text
            max-width: 120px
            &--full
                p
                    white-space: nowrap
                    overflow-x: hidden
                    text-overflow: ellipsis
            &--label
                text-transform: uppercase
                font-size: 11px
                font-weight: 500
                color: #bec7d3

</style>
